import React from 'react';

import AssaMovil from '../../svg/assamovil.svg';

export const ASSAMOVIL = '0028';

// Mapping
export const mapping: { [key: string]: React.ReactNode } = {
  [ASSAMOVIL]: <img alt="art" src={AssaMovil} />,
};

export default function imageForSpecialCoverage(code: string): React.ReactNode {
  if (Object.keys(mapping).includes(code)) {
    return mapping[code];
  }
  return code;
}
